
import { BasicModel } from "@goodgamestudios/core";
import { BasicCustomCursor } from "@goodgamestudios/core";
import { TextFormat } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { Poker2Constants } from "../../constants/Poker2Constants";
import { SFConstants } from "../../constants/SFConstants";
import { Poker2ChatEvent } from "../../event/Poker2ChatEvent";
import { Poker2SliderEvent } from "../../event/Poker2SliderEvent";
import { LobbyTablesVO } from "../../gamevo/LobbyTablesVO";
import { SeatVO } from "../../gamevo/SeatVO";
import { Poker2Model } from "../../model/Poker2Model";
import { SliderHelper } from "./SliderHelper";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

export class TableLogHelper {
    private logslider: SliderHelper;
    private logHeight: number = 0;
    private logkomponent: MovieClip;

    constructor(komponent: MovieClip) {
        this.logkomponent = komponent;

        // apply mask via code to fix a text view problem in flashplayer 11
        this.logkomponent.mc_textholder.mask = this.logkomponent.mc_mask;

        // init scrollbar (using slider as a scrollbar)
        this.logslider = new SliderHelper(this.logkomponent.mc_chatslider);

        // init listeners
        this.logkomponent.mc_chatslider.addEventListener("onSliding", this.bindFunction(this.onChatSliding));
        this.logkomponent.mc_chatslider.addEventListener("slideUp", this.bindFunction(this.onChatSliding));
        this.logkomponent.mc_chatslider.addEventListener("slideDown", this.bindFunction(this.onChatSliding));
    }

    private scrollToEnd(): void {
        if (this.extraLogHeight > this.logkomponent.mc_mask.height) {
            this.logkomponent.mc_textholder.y = this.logkomponent.mc_mask.y - (this.extraLogHeight - this.logkomponent.mc_mask.height);
            this.enableButtons(true);
        }
        this.updateSlider();
    }

    private onChatSliding(event: Poker2SliderEvent): void {
        if (this.extraLogHeight <= this.logkomponent.mc_mask.height) return;
        this.logkomponent.mc_textholder.y = this.logkomponent.mc_mask.y - (this.extraLogHeight - this.logkomponent.mc_mask.height) * event.percentValue / 100;
    }

    private updateSlider(): void {
        if (this.extraLogHeight < this.logkomponent.mc_mask.height) return;

        var textholderY: number = int(this.logkomponent.mc_textholder.y - this.logkomponent.mc_mask.y);
        var height: number = int(-(this.extraLogHeight - this.logkomponent.mc_mask.height));
        var percentY: number = 100 - ((height - textholderY) / height * 100);
        this.logkomponent.mc_chatslider.btn_slider.y = this.logkomponent.mc_chatslider.mc_sliderbar.y + (this.logkomponent.mc_chatslider.mc_sliderbar.height * percentY / 100);
    }

    public onAddMsg(event: Poker2ChatEvent): void {
        if (event.userId < 0 && event.playerId < 0) {
            this.writeNewMsg(-1, -1, "GAME", int(0x000000), event.msg);
            return;
        }
        var currentTable: LobbyTablesVO = Poker2Model.onTableData.currentTable;
        for (var i: number = 0; i < currentTable.seats.length; i++) {
            var seatVO: SeatVO = currentTable.seats[i] as SeatVO;
            //Da Zombies auch offline spielen keine Abfrage nach userId!
            if (seatVO.playerId == event.playerId) {
                this.writeNewMsg(seatVO.userId, seatVO.playerId, seatVO.name, int(Poker2Constants.SEAT_COLOR[i]), event.msg);
                return;
            }
        }
    }

    private writeNewMsg(userId: number, playerId: number, playerName: string, color: number, msg: string): void {
        var namefield: Library.PokerTableActionPanel.ChatNameText = new Library.PokerTableActionPanel.ChatNameText();
        var msgfield: Library.PokerTableActionPanel.ChatMsgText = new Library.PokerTableActionPanel.ChatMsgText();

        namefield.txt_msg.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        msgfield.txt_msg.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;

        if (Poker2LanguageFontManager.getInstance().useDefaultFont) {
            Poker2LanguageFontManager.getInstance().changeFontByLanguage(namefield.txt_msg);
            Poker2LanguageFontManager.getInstance().changeFontByLanguage(msgfield.txt_msg);
        }
        else {
            namefield.txt_msg.embedFonts = false;
            msgfield.txt_msg.embedFonts = false;
        }

        namefield.txt_msg.text = playerName + ": ";
        namefield.txt_msg.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        namefield.txt_msg.width = namefield.txt_msg.textWidth + 5;
        namefield.txt_msg.height = namefield.txt_msg.textHeight + 5;
        namefield.txt_msg.textColor = color;
        namefield.txt_msg.mouseEnabled = true;

        if (userId > 0 && userId != Poker2Model.userData.userID) {
            namefield.mouseChildren = false;
            namefield.userId = userId;
            namefield.playerId = playerId;
            namefield.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickNameField));
            namefield.addEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOutNameField));
            namefield.addEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOverNameField));
        }
        msgfield.mouseEnabled = false;
        msgfield.mouseChildren = false;
        msgfield.x = namefield.txt_msg.width;
        var format: TextFormat = msgfield.txt_msg.defaultTextFormat;

        msgfield.txt_msg.defaultTextFormat = format;
        msgfield.txt_msg.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        msgfield.txt_msg.text = msg;
        msgfield.txt_msg.width = this.logkomponent.mc_mask.width - namefield.txt_msg.width - 1;
        msgfield.txt_msg.height = msgfield.txt_msg.textHeight + 5;

        msgfield.y = namefield.y = this.logHeight;
        msgfield.y += 1;

        this.logkomponent.mc_textholder.addChild(msgfield);
        this.logkomponent.mc_textholder.addChild(namefield);

        //logHeight = logkomponent.mc_textholder.height;
        this.logHeight += int(msgfield.height - 4);
        this.scrollToEnd();
    }

    private get extraLogHeight(): number {
        return this.logHeight + 5;
    }

    private onClickNameField(event: MouseEvent): void {
        var namefield: Library.PokerTableActionPanel.ChatNameText = event.target as Library.PokerTableActionPanel.ChatNameText;
        var paramObject: any = { id: namefield.playerId, viewId: 1 };
        BasicModel.smartfoxClient.sendMessage("gpv", [JSON.stringify(paramObject)]);
    }

    private onMouseOutNameField(event: MouseEvent): void {
        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
    }
    private onMouseOverNameField(event: MouseEvent): void {
        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
    }

    public init(): void {
        this.enableButtons(false);
        this.logHeight = 0;
        while (this.logkomponent.mc_textholder.numChildren > 0) {
            var child: DisplayObject = this.logkomponent.mc_textholder.getChildAt(0);
            if (instanceOfClass(child, "ChatNameText")) {
                child.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickNameField));
                child.removeEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOutNameField));
                child.removeEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOverNameField));
            }
            this.logkomponent.mc_textholder.removeChildAt(0);
        }
        this.logkomponent.mc_textholder.y = this.logkomponent.mc_mask.y;
    }

    private enableButtons(able: boolean): void {
        this.logkomponent.mc_chatslider.btn_slider.enableButton = able;
        this.logkomponent.mc_chatslider.btn_up.enableButton = able;
        this.logkomponent.mc_chatslider.btn_down.enableButton = able;
    }

    public destory(): void {
        this.logkomponent.mc_chatslider.removeEventListener("onSliding", this.bindFunction(this.onChatSliding));
        this.logkomponent.mc_chatslider.removeEventListener("slideUp", this.bindFunction(this.onChatSliding));
        this.logkomponent.mc_chatslider.removeEventListener("slideDown", this.bindFunction(this.onChatSliding));
        if (this.logslider) this.logslider.destroy();
        this.logslider = null;
    }

}
import { Poker2LanguageFontManager } from "../Poker2LanguageFontManager";
import { Poker2LayoutManager } from "../Poker2LayoutManager";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
